import { IThunkActionCreator } from '../../../types/store';
import { getSeoMarkedList } from '../../../api/getSeoMarkedList';
import { getSearchResultMetrics } from '../../../api/getSearchResultMetrics';
import { IMarkedList } from '../../../types/seo';
import { IGetVillageListRequestSchema } from '../../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';

export enum MarkedListActionTypes {
  Fetched = 'MarkedListFetched',
}

export interface IMarkedListFetched {
  data?: IMarkedList;
  type: MarkedListActionTypes.Fetched;
}

export function fetchMarkedList(filters: IGetVillageListRequestSchema): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger }) => {
    const {
      seo: { pageData },
      villageList: { totalItems },
    } = getState();

    if (!pageData?.id) {
      dispatch<IMarkedListFetched>({
        data: undefined,
        type: MarkedListActionTypes.Fetched,
      });

      return;
    }

    const searchResultMetrics = await getSearchResultMetrics(httpApi, logger, filters, totalItems);

    const markedList = searchResultMetrics
      ? await getSeoMarkedList(httpApi, logger, { seoUrlId: pageData.id, searchResultMetrics })
      : null;

    if (!markedList) {
      dispatch<IMarkedListFetched>({
        data: undefined,
        type: MarkedListActionTypes.Fetched,
      });

      return;
    }

    dispatch<IMarkedListFetched>({
      data: markedList,
      type: MarkedListActionTypes.Fetched,
    });
  };
}

export type TMarkedListAction = IMarkedListFetched;
